

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import * as s_Interface from '@/interface/store/manageGroups';

const namespace = 'manageGroup';

@Component
export default class MobileAddressesCard extends Vue {
  @Prop({ default: [] }) addresses!: Array<s_Interface.Addresses>;
  @Prop({ default: () => {} }) addAddressOpen!: (mode: string, id: any) => {};
  @Prop({ default: () => {} }) deleteAddress!: (item: any) => {};
  @Prop({ default: [] }) selectIdx!: any;
  @Prop() isAdmin!: boolean;
}
